import Vue from "vue";

Vue.component("wto-extract-url", {
	props: ["text"],
	data() {
		return {
			url: ""
		};
	},
	methods: {
		extractUrl: function (text) {
			let returnValue = '';

			if (text) {
				const expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
				let urls = text.match(expression);
				if (urls) {
					urls.forEach(function (item) {
						returnValue += "<a href=" + item + " target='_blank'>" + item + "</a><br>"
					})
				}			
			}

			this.url = returnValue;
		}
	},
	mounted() {
		this.extractUrl(this.text);
	},
	template: `
		<span v-html="url"></span>
	`
});